import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
    fonts: {
        heading: `'Press Start 2P', sans-serif`,
        body: `'Press Start 2P', sans-serif`,
    }
});

export default theme;